const BASE_URL = process.env.REACT_APP_URL + navigator.language.slice(0,2) + '/api/';
const BASE_URL_PRIVATE = BASE_URL + 'private/';

export default class {
    public static URL_UPDATE_EXPIRATION_CARDS = `${BASE_URL_PRIVATE}user/update-expiration-date-card`;
}